export default __webpack_public_path__ + "static/media/step_G_2_EN.2adb52b5.png";